<template>
  <div class="right-click-menu">
    <div class="right-click-menu__title">
      <span>{{ data.b_name }}</span>
      <span v-if="data.room_no" style="margin-left: 3px">{{ data.room_no }}号室</span>
      <span style="margin-left: 3px">(ID:{{ data.id }})</span>
    </div>
    <div class="right-click-menu__inner">
      <div class="property section-box">
        <div class="section-title">
          <img :src="icons.building.path" :alt="icons.building.alt" class="menu-icon">
          <span>【物件操作】</span>
        </div>
        <div class="list-right-click">
          <div class="list-right-click__item">
            <a href="javascript:void(0)" @click="onClickCreate">
              <img :src="icons.add.path" :alt="icons.add.alt" class="menu-icon">
              <span>物件新規追加</span>
            </a>
          </div>
          <div class="list-right-click__item">
            <a href="javascript:void(0)" @click="onClickEdit">
              <img :src="icons.edit.path" :alt="icons.edit.alt" class="menu-icon">
              <span>物件編集</span>
            </a>
          </div>
          <div class="list-right-click__item">
            <a href="javascript:void(0)" @click="onClickCopy">
              <img :src="icons.copy.path" :alt="icons.copy.alt" class="menu-icon">
              <span>物件コピー</span>
            </a>
          </div>
          <div class="list-right-click__item list-right-click__item--separator">
            <a href="javascript:void(0)" @click="onClickDelete" style="color: #f00;">
              <img :src="icons.delete.path" :alt="icons.delete.alt" class="menu-icon">
              <span>物件削除</span>
            </a>
          </div>
        </div>
      </div>
      <div class="other section-box">
        <div class="section-title">
          <img :src="icons.settings.path" :alt="icons.settings.alt" class="menu-icon">
          <span>【ツール・その他】</span>
        </div>
        <div class="list-right-click">
          <div class="list-right-click__item">
            <a href="javascript:void(0)" @click="onClickHappyCall">
              <img :src="icons.view.path" :alt="icons.view.alt" class="menu-icon">
              <span>物件確認</span>
            </a>
          </div>
          <div class="list-right-click__item">
            <a href="javascript:void(0)" @click="onClickMap">
              <img :src="icons.map.path" :alt="icons.map.alt" class="menu-icon">
              <span>マップ</span>
            </a>
          </div>
          <div class="list-right-click__item">
            <a href="javascript:void(0)" @click="onClickMadorinosuke">
              <img
                src="@/assets/img/ai-floor-plan.svg"
                alt=""
                class="menu-icon"
              >
              <span>間取之助Cloud+AI</span>
            </a>
          </div>
          <!-- TODO １月末リリースには不要の為、コメントアウト -->
          <!-- <div class="list-right-click__item">
            <a href="javascript:void(0)" @click="onClickMenu()">POP出力</a>
          </div> -->
          <!-- TODO １月末リリースには不要の為、コメントアウト -->
          <!-- <div class="list-right-click__item">
            <a href="javascript:void(0)" @click="onClickMenu()">URL生成</a>
          </div> -->
          <!-- TODO １月末リリースには不要の為、コメントアウト -->
          <!-- <div class="list-right-click__item">
            <a href="javascript:void(0)" @click="onClickImageViewer">画像ビューア</a>
          </div> -->
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import PropertyDelete from '@/mixins/delete'
import { isResidence, isInvestment } from '@/util/m_b_type.js'
import { RIGHT_CLICK_MENU_ICONS } from '@/constants/right-click-menu-icons'

const EDITOR_URL = `${process.env.VUE_APP_EDITOR_DOMAIN}/edit`
const newWindowOption =
  'left=50,top=50,width=1000,height=416,scrollbars=0,location=0,menubar=0,toolbar=0,status=1,directories=0,resizable=1'

export default {
  mixins: [PropertyDelete],
  components: {},
  props: {
    data: {
      type: Object,
      default: () => {},
      requied: true,
    },
  },
  data() {
    return {
      icons: RIGHT_CLICK_MENU_ICONS,
    }
  },
  computed: {
    user() {
      return this.$store.getters['User/getUser']
    },
    permissions() {
      return this.$store.getters['User/getPermissions']
    },
  },
  methods: {
    // 物件新規追加
    onClickCreate() {
      let type = ''
      if (isResidence(this.data.m_b_type_id)) type = 'residence'
      if (isInvestment(this.data.m_b_type_id)) type = 'investment'
      this.$store.dispatch('ModalNewPropertyLinkList/set', { tab: type })
    },
    // 物件編集
    onClickEdit() {
      let type = ''
      if (isResidence(this.data.m_b_type_id)) type = 'residence'
      if (isInvestment(this.data.m_b_type_id)) type = 'investment'
      window.open(`${EDITOR_URL}/${type}/${this.data.id}/regulars`, '_blank')
    },
    // 物件コピー
    onClickCopy() {
      const property = this.data
      this.$store.dispatch('ModalPropertyCopy/set', { property: property })
    },
    // 物件削除
    onClickDelete() {
      if (this.permissions.f_cant_b_single_del) {
        // 認証
        this.$store.commit('ModalAuth/setType', 'b_delete')
        this.$store.commit('ModalAuth/setItem', { id: this.data.id })
        this.$store.commit('ModalAuth/setModal', true)
      } else {
        this.deleteConfirm(this.data.id)
      }
    },
    // マップ
    onClickMap() {
      window.open(`/map/${this.data.id}`, '_blank', newWindowOption)
    },
    // 画像ビューアー
    onClickImageViewer() {
      window.open(`/image_viewer/${this.data.id}`, '_blank', newWindowOption)
    },
    // 物件確認
    onClickHappyCall() {
      this.$store.dispatch('ModalHappyCall/set', this.data)
    },
    onClickMadorinosuke() {
      const params = new URLSearchParams({
        shop_id: this.user.shop_id,
        room_id: `s-${this.data.id}`,
        source: 'sale_list',
      })
      const url = `${process.env.VUE_APP_MADORINOSUKE_URL}/editor?${params.toString()}`
      window.open(url, '_blank')
    },
  },
}
</script>

<style lang="scss" scoped>
.right-click-menu {
  font-size: 13px;
  &__title {
    color: #000;
    padding: 0 6px 6px;
    font-size: 14px;
    font-weight: bold;
  }
  &__inner {
    display: flex;
    gap: 10px;
  }
  .property {
    flex: 180px 0 0;
    background-color: #edfaf7;
  }
  .other {
    flex: 195px 0 0;
    background-color: #fff9e8;
  }
  .section-box {
    padding: 7px;
    border-radius: 6px;
    border: 1px solid #00000014;
  }
  .section-title {
    font-size: 14px;
    font-weight: bold;
    display: flex;
    align-items: center;
    gap: 7px;
    padding-bottom: 4px;
  }
  .menu-icon {
    width: 18px;
  }
  .list-right-click {
    padding-top: 4px;
    &__item {
      a {
        display: flex;
        align-items: center;
        gap: 7px;
        padding: 4px 0;
        color: #333;
        transition: ease 0.3s;
        &:hover {
          background-color: #f0f0f0;
          transition: ease 0.3s;
        }
      }
      &--separator {
        position: relative;
        margin-top: 4px;
        padding-top: 4px;
        &::before {
          position: absolute;
          top: 0;
          right: 0;
          left: 0;
          height: 1px;
          background-color: #00000014;
          content: '';
        }
      }
    }
  }
}
</style>
